function addDailyPoints(type) {
    if (type==="glow") {
        console.log("hi")
    } else {

    }
    return
}

export default addDailyPoints;